import type { TreeNode } from '../../types/ui';

/**
 * Find the first navigable tree node whose sub-schema declares the given
 * leaf segment as a top-level property. Used to bridge backend pointers
 * that are abbreviated relative to the actual schema layout (e.g. the
 * backend returns `/data/attributes/campaignNodes` even though the field
 * actually lives at `attributes.flowTemplate.campaignNodes`) onto a
 * navigable section the form can open and a property schema we can read
 * a label from.
 *
 * Returns `undefined` when the nodeMap has no node whose schema's
 * `properties` map contains `leafSegment`. Both `findNavigableFormPath`
 * (for the banner link target) and the entity-details page's label
 * resolver call into this so the heuristic stays in one place.
 */
export const findPropertyHostNode = (
  leafSegment: string,
  nodeMap: Map<string, TreeNode>,
): TreeNode | undefined =>
  Array.from(nodeMap.values()).find((node) => {
    const properties = node.data?.schema?.properties;
    return (
      Boolean(properties) &&
      Object.prototype.hasOwnProperty.call(properties, leafSegment)
    );
  });
